<template>
  <div class="content--sinoreg">
    <div class="SelosEOSCancelados">
      <div class="SelosEOSCancelados_header p-3">
        Selos e Ordens de Serviço Canceladas
      </div>
      <div class="SelosEOSCancelados_filters px-3 py-2">
        <div class="form-group">
          <label for=""
                 class="label SelosEOSCancelados_label py-1">
            Mostrar:
          </label>
          <div class="row">
            <div class="col-3">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  id="os"
                  v-model="tipo"
                  class="custom-control-input"
                  name="os"
                  required
                  type="radio"
                  value="os"
                  @change="changeTipo()">
                <label class="custom-control-label SelosEOSCancelados_label"
                       for="os">Ordens de Serviço Canceladas</label>
              </div>
            </div>
            <div class="col-2">
              <div class="custom-control custom-radio custom-control-inline">
                <input
                  id="selos"
                  v-model="tipo"
                  class="custom-control-input"
                  name="selos"
                  required
                  type="radio"
                  value="selos"
                  @change="changeTipo()">
                <label class="custom-control-label SelosEOSCancelados_label"
                       for="selos">Selos cancelados</label>
              </div>
            </div>
          </div>
        </div>
        <div v-if="tipo === 'os'">
          <div class="col-12 d-inline-flex m-0 p-0">
            <div class="col-4 form-group p-0 mr-3">
              <label for="data"
                     class="label">Data da OS</label>
              <div id="data"
                   class="d-inline-flex align-items-top">
                <div class="form-group m-0 p-0">
                  <input id="inicio_os"
                         v-model="localData.data_inicial_os"
                         v-validate="{required: !!localData.data_final_os}"
                         type="date"
                         name="inicio_os"
                         class="form-control form-control-sm"
                         :class="{'is-invalid': errors.has('inicio_os')}">
                  <span v-if="errors.has('inicio_os')"
                        class="invalid-feedback">
                    {{ localData.data_incial_os ? errors.first("inicio_os") : 'Data obrigatória' }}
                  </span>
                </div>
                <p class="p-0 m-0 mx-2 mt-1 label">
                  até
                </p>
                <div class="form-group m-0 p-0">
                  <input id="fim_os"
                         v-model="localData.data_final_os"
                         v-validate="{required: !!localData.data_inicial_os}"
                         type="date"
                         name="fim_os"
                         class="form-control form-control-sm"
                         :class="{'is-invalid': errors.has('fim_os')}">
                  <span v-if="errors.has('fim_os')"
                        class="invalid-feedback">
                    {{ localData.data_final_os ? errors.first("fim_os") : 'Data obrigatória' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-4 form-group p-0 ml-3">
              <label for="data"
                     class="label">Data do Cancelamento</label>
              <div id="data"
                   class="d-inline-flex align-items-top">
                <div class="form-group m-0 p-0">
                  <input id="inicio_cancelamento"
                         v-model="localData.data_inicial_cancelamento"
                         v-validate="{required: !!localData.data_final_cancelamento}"
                         type="date"
                         name="inicio_cancelamento"
                         class="form-control form-control-sm"
                         :class="{'is-invalid': errors.has('inicio_cancelamento')}">
                  <span v-if="errors.has('inicio_cancelamento')"
                        class="invalid-feedback">
                    {{ localData.data_inicial_cancelamento ? errors.first("inicio_cancelamento") : 'Data obrigatória' }}
                  </span>
                </div>
                <p class="p-0 m-0 mx-2 mt-1 label">
                  até
                </p>
                <div class="form-group m-0 p-0">
                  <input id="fim_cancelamento"
                         v-model="localData.data_final_cancelamento"
                         v-validate="{required: !!localData.data_inicial_cancelamento}"
                         type="date"
                         name="fim_cancelamento"
                         class="form-control form-control-sm"
                         :class="{'is-invalid': errors.has('fim_cancelamento')}">
                  <span v-if="errors.has('fim_cancelamento')"
                        class="invalid-feedback">
                    {{ localData.data_final_cancelamento ? errors.first("fim_cancelamento") : 'Data obrigatória' }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div class="row mb-3">
            <div class="col-4 p-0 m-0 pl-3 mr-3">
              <div class="form-group m-0 p-0">
                <label for="matricula"
                       class="label">
                  Número da matrícula
                </label>
                <input v-model.trim="localData.matricula"
                       v-mask="'999999 99 99 9999 9 99999 999 9999999 99'"
                       type="text"
                       class="form-control form-control-sm">
              </div>
            </div>
            <div class="col-3 p-0 m-0 mx-3">
              <div class="form-group m-0 p-0">
                <label for="matricula"
                       class="label">
                  Número da Ordem de Serviço
                </label>
                <input v-model="localData.numero_os"
                       type="number"
                       min="0"
                       class="form-control form-control-sm">
              </div>
            </div>
            <div class="d-flex align-items-end">
              <button class="btn btn-sm btn-outline-primary px-3 ml-3"
                      @click="searchOS()">
                Filtrar
              </button>
            </div>
          </div>
        </div>
        <div v-else>
          <div class="d-inline-flex align-items-start m-0 p-0 col-12">
            <div class="col-4 form-group p-0 mr-3">
              <label for="data"
                     class="label">Data do Cancelamento</label>
              <div id="data"
                   class="d-inline-flex align-items-top">
                <div class="form-group m-0 p-0">
                  <input id="inicio_cancelamento_selos"
                         v-model="localData.data_inicial_cancelamento"
                         type="date"
                         name="inicio_cancelamento_selos"
                         class="form-control form-control-sm"
                         :class="{'is-invalid': errors.has('inicio_cancelamento_selos') || showErrorDataInicial}"
                         @change="changeErrors()">
                  <span v-if="errors.has('inicio_cancelamento_selos') || showErrorDataInicial"
                        class="invalid-feedback">
                    {{ localData.data_inicial_cancelamento ? errors.first("inicio_cancelamento_selos") : 'Data obrigatória' }}
                  </span>
                </div>
                <p class="p-0 m-0 mx-2 mt-1 label">
                  até
                </p>
                <div class="form-group m-0 p-0">
                  <input id="fim_cancelamento_selos"
                         v-model="localData.data_final_cancelamento"
                         type="date"
                         name="fim_cancelamento_selos"
                         class="form-control form-control-sm"
                         :class="{'is-invalid': errors.has('fim_cancelamento_selos') || showErrorDataFinal}"
                         @change="changeErrors()">
                  <span v-if="errors.has('fim_cancelamento_selos') || showErrorDataFinal"
                        class="invalid-feedback">
                    {{ localData.data_final_cancelamento ? errors.first("fim_cancelamento_selos") : 'Data obrigatória' }}
                  </span>
                </div>
              </div>
            </div>
            <div class="col-3 p-0 m-0 mx-3">
              <div class="form-group m-0 p-0">
                <label for="matricula"
                       class="label">
                  Número do selo
                </label>
                <input v-model="localData.numero_selo"
                       class="form-control form-control-sm">
              </div>
            </div>
            <div class="mt-4">
              <button class="btn btn-sm btn-outline-primary px-3 ml-2"
                      @click="searchSelos()">
                Filtrar
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="lista.length"
           class="SelosOSCancelados_list">
        <hr class="m-0 mb-3">
        <ListaOSCanceladas v-if="tipo === 'os'"
                           :prop-lista-os="lista" />
        <ListaSelosCancelados v-else
                              :prop-lista-selos="lista" />
        <hr>
      </div>
      <div v-if="lista.length"
           class="SelosEOSCancelados_footer col-12 justify-content-center align-items-center p-0 m-0 mt-2">
        <Pagination
          :per-page="perPage"
          :page="page"
          :last-page="lastPage"
          @onPreviousPage="reload(page - 1)"
          @onNextPage="reload (page + 1)" />
      </div>
    </div>
  </div>
</template>
<script>
  /** components */
  import ListaOSCanceladas from "@/components/SelosOsCanceladas/ListaOSCanceladas"
  import ListaSelosCancelados from "@/components/SelosOsCanceladas/ListaSelosCancelados"
  import Pagination from "@/components/SofiaRei/Pagination"

  /** service */
  import OrdensServicoService from "@/services/Registros/OrdensServicoService"
  import SelosService from "@/services/Registros/SelosService"

  import { mapGetters } from 'vuex'

  export default {
    name: "SelosEOSCancelados",
    components: {
      ListaOSCanceladas,
      ListaSelosCancelados,
      Pagination
    },
    data () {
      return {
        tipo: 'os',
        lista: [],
        localData: {
          data_inicial_os: null,
          data_final_os: null,
          data_inicial_cancelamento: null,
          data_final_cancelamento: null,
          matricula: null,
          numero_os: null,
          numero_selo: null,
        },
        page: 1,
        perPage: 20,
        lastPage: 1,
        search: {},
        showErrorDataFinal: false,
        showErrorDataInicial: false
      }
    },
    computed: {
      ...mapGetters({
        cartorioId: 'auth/getCartorioId'
      }),
    },
    methods: {
      async searchOS () {
        const valid = await this.$validator.validate()

        if (!valid) return

        try {
          loader({active: true})
          const matricula = this.localData.matricula ? this.localData.matricula.replace(/ /g, '') : null

          const res = await OrdensServicoService.getOsCanceladas({...this.localData, matricula})

          if (res.data.length) {
            this.search = {...this.localData, matricula}
            this.lista = res.data
            this.page = res.page
            this.lastPage = res.lastPage
            this.perPage = res.perPage
          } else {
            this.lista = []

            return displayMessage("error", null, "Nenhuma ordem de serviço encontrada!")
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false})
        }
      },
      async searchSelos () {
        if (!!this.localData.data_inicial_cancelamento && !this.localData.data_final_cancelamento) {
          this.showErrorDataFinal = true
          return
        } else if (!this.localData.data_inicial_cancelamento && !!this.localData.data_final_cancelamento) {
          this.showErrorDataInicial = true
          return
        }

        try {
          loader({active: true})
          const res = await SelosService.getSelosCancelados(this.localData)

          if (res.data.length) {
            this.search = {...this.localData}
            this.lista = res.data.filter(item => item.seloItemOs.ordemServicoItem.ordemServico.cartorio_id == this.cartorioId)
            this.page = res.page
            this.lastPage = res.lastPage
            this.perPage = res.perPage
          } else {
            this.lista = []

            return displayMessage("error", null, "Nenhuma ordem de serviço encontrada!")
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false})
        }
      },
      reload (page = 1) {
        if (this.tipo === 'os') {
          this.reloadOS(page)
        } else {
          this.reloadSelos(page)
        }
      },
      async reloadOS (page) {
        try {
          loader({active: true, text: ""})

          const params = {
            ...this.search,
            page,
            perPage: this.perPage
          }

          const res = await OrdensServicoService.getOsCanceladas(params)

          if (res.data.length) {
            this.lista = res.data
            this.page = res.page
            this.lastPage = res.lastPage
          } else if (page > 1) {
            this.reloadOS(this.page - 1)
          }  else  {
            if (page === 1) {
              this.lista = []
              this.page = 1
              this.lastPage = 1
            }

            return displayMessage("error", null, "Nenhuma ordem de serviço encontrada!")
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ""})
          this.scrollList()
        }
      },
      async reloadSelos (page) {
        try {
          loader({active: true, text: ""})

          const params = {
            ...this.search,
            page,
            perPage: this.perPage
          }

          const res = await SelosService.getSelosCancelados(params)

          if (res.data.length) {
            this.lista = res.data
            this.page = res.page
            this.lastPage = res.lastPage
          } else if (page > 1) {
            this.reloadOS(this.page - 1)
          }  else  {
            if (page === 1) {
              this.lista = []
              this.page = 1
              this.lastPage = 1
            }

            return displayMessage("error", null, "Nenhum selo encontrado!")
          }
        } catch (error) {
          const message = getErrors(error)

          return displayMessage('error', 'Erro!', message.message)
        } finally {
          loader({active: false, text: ""})
          this.scrollList()
        }
      },
      scrollList () {
        setTimeout(() => {
          const listagem = document.querySelectorAll('#os')

          if (listagem.length) {
            listagem[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: "start" })
          }
        }, 100)
      },
      changeTipo () {
        this.lista = []
        this.search = {}
        this.page = 1,
        this.perPage = 10,
        this.lastPage = 1
        this.localData = {
          data_inicial_os: null,
          data_final_os: null,
          data_inicial_cancelamento: null,
          data_final_cancelamento: null,
          matricula: null,
          numero_os: null,
          numero_selo: null,
        }
      },
      changeErrors ()  {
        if (!!this.localData.data_final_cancelamento) {
          this.showErrorDataFinal = false
        }

        if (!!this.localData.data_inicial_cancelamento) {
          this.showErrorDataInicial = false
        }

        if (!this.localData.data_final_cancelamento && !this.localData.data_inicial_cancelamento) {
          this.showErrorDataFinal = false
          this.showErrorDataInicial = false
        }
      }
    }
  }
</script>
<style lang="scss">
.SelosEOSCancelados {
  &_header {
    font-family: Roboto;
    font-size: 1.25rem;
    font-weight: 500;
    font-style: normal;
    line-height: 1.33;
    color: #ffffff;
    background: #074f7f;
  }

  &_body {

  }

  &_label {
    color: #373a3c;
    font-weight: normal;
  }
}
</style>
